var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dtwin-container"},[_c('VerticalBanner',{attrs:{"lists":_vm.bannersList,"indicatorPosition":'none',"height":'640px',"isShowMore":true},on:{"click":_vm.openUrl}}),_c('Solution'),_c('TwinHighwayIntro'),_c('TwinWaterwayIntro'),_c('TwinCityIntro'),_c('ProductGet',{attrs:{"title":"基础设施运维数字孪生解决方案","subTitle":"为道路、航道、城市基础设施运维管理带来全新模式！","bgImage":require('@/assets/images/dtwin/getNow_bg.png'),"contactBtn":null,"downLoadBtn":{
      label: '下载产品手册',
      fileUrl: '/download?anchor=manual',
      show: true,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }